import React from 'react';

export default props => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1 7.5l-.724-.736L8.76 3.15l-.707.707L11.198 7H1.905v1h9.292l-3.145 3.143.707.707 3.65-3.648.691-.701z"
      fill="#afafaf"
    />
  </svg>
);
